import React, { useState } from 'react';
import styles from './AppFooter.module.scss';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

interface AppFooterProps {
  className?: string;
}
const importantNotes = '/legal/important-program-notes';
const privacyPolicy = '/legal/privacy-policy';
const termsAndConditions = '/legal/terms-and-conditions';
const relatedLinks = '/legal/related-links';

const AppFooter: React.FC<AppFooterProps> = ({ className }) => {
  const [hoveredLink, setHoveredLink] = useState<string | null>(null);
  const pathname = usePathname();

  const footerTextStyle = {
    color: 'rgb(217, 217, 217)',
    transition: 'color 150ms ease-in-out'
  };

  const getLinkStyle = (linkName: string, path: string) => {
    const isActive = pathname === path;
    return {
      ...footerTextStyle,
      color: isActive ? '#fff' : (hoveredLink === linkName ? '#fff' : 'rgb(217, 217, 217)'),
      textDecoration: isActive ? 'underline' : 'none'
    };
  };
  
  return (
   <footer className={`${styles.footer} ${className} !bg-[#122377] text-[12.8px] !text-left`} style={footerTextStyle}>
    <div className='container'>
      <Link 
        href={importantNotes} 
        style={getLinkStyle('important-notes', importantNotes)}
        onMouseEnter={() => setHoveredLink('important-notes')}
        onMouseLeave={() => setHoveredLink(null)}
      >
        Important Notes
      </Link>
      <span className='!pl-3 !pr-3'>|</span>
      <Link 
        href={privacyPolicy}
        style={getLinkStyle('privacy-policy', privacyPolicy)}
        onMouseEnter={() => setHoveredLink('privacy-policy')}
        onMouseLeave={() => setHoveredLink(null)}
      >
        Privacy Policy
      </Link>
      <span className='!pl-3 !pr-3'>|</span>
      <Link 
        href={termsAndConditions}
        style={getLinkStyle('terms', termsAndConditions)}
        onMouseEnter={() => setHoveredLink('terms')}
        onMouseLeave={() => setHoveredLink(null)}
      >
        Terms of Use
      </Link>
      <span className='!pl-3 !pr-3'>|</span>
      <span className='!text-[#fff]'>Copyright @ {new Date().getFullYear()} UnitedHealth Group, Incorporated. All rights reserved.</span>
    </div>
  </footer>
  );
};

export default AppFooter;
